import { UserRoles } from './types';
import usersAPISlice from './usersAPISlice';

type CurrentUserRoles = {
  isCollector: boolean;
  isCoordinator: boolean;
  isLegalRep: boolean;
  isAdmin: boolean;
};

const useCurrentUserRoles = (): CurrentUserRoles => {
  const { data: currentUser } = usersAPISlice.endpoints.getCurrentUser.useQuery();
  const role = currentUser?.roles[0];

  return {
    isCollector: role === UserRoles.Collector,
    isCoordinator: role === UserRoles.Coordinator,
    isLegalRep: role === UserRoles.LegalRepresentative,
    isAdmin: currentUser?.admin === true,
  };
};

export default useCurrentUserRoles;
